import React from 'react';
import { Accordion } from '@drone-js/core';
import { mapStateToProps, mapDispatchToProps, AccordionContainerProps } from 'component/page/detail/DetailPageModularize/ContentWrapper/ContentWrapper.selectors';
import { connect, useSelector } from 'react-redux';
import { ContainerDisplayVariant, AccordionVariant } from 'component/page/detail/DetailPageModularize/detailPageModularize.types';
import { selectCmsFromBootstrap, selectIsBotOrIsPrerenderFromBootstrap } from 'store/slice/bootstrap';
import { useInView } from 'react-intersection-observer';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import {
    ActivitiesAccordionContainerClickEventActivitiesManifestV1,
    ActivitiesAccordionContainerSeenEventActivitiesManifestV1,
} from '@agoda/analytics-messages-definition-activities/manifest/events';
import { ActivitiesAccordionContainerSeenEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ExpandabilityState } from 'core/type/Details.types';

const AccordionContainer: React.FC<AccordionContainerProps> = (props) => {
    const isAccordion = props.display === ContainerDisplayVariant.Accordion;
    const cms = useSelector(selectCmsFromBootstrap);
    const isBotOrIsPrerender = useSelector(selectIsBotOrIsPrerenderFromBootstrap);
    const { href, elementName, titleCms, dynamicTitle } = props.customMeta;
    const displayTitle = dynamicTitle || cms[titleCms] || '';

    const onSeen = (inView: boolean) => {
        if (inView) {
            trackElementEvent<ActivitiesAccordionContainerSeenEventActivitiesFieldsV1>(ActivitiesAccordionContainerSeenEventActivitiesManifestV1.ids, {
                expandability_state: isAccordion && props.accordionVariant === AccordionVariant.Expanded ? ExpandabilityState.Expanded : ExpandabilityState.Collapsed,
                action_element_value: displayTitle,
            });
        }
    };

    const { ref } = useInView({
        threshold: 0.75,
        triggerOnce: true,
        onChange: onSeen,
    });

    if (!isAccordion) {
        return <>{props.children}</>;
    }

    const defaultView = props.accordionVariant === AccordionVariant.Expanded ? 'expanded' : 'collapsed';
    const isStoreExpanded = props.expandedModularAccordion[`#${href}`];
    const view = isBotOrIsPrerender || isStoreExpanded ? 'expanded' : isStoreExpanded === undefined ? defaultView : 'collapsed';

    const onToggle = (isExpanded: boolean) => {
        trackElementEvent<ActivitiesAccordionContainerSeenEventActivitiesFieldsV1>(ActivitiesAccordionContainerClickEventActivitiesManifestV1.ids, {
            expandability_state: isExpanded ? ExpandabilityState.Expanded : ExpandabilityState.Collapsed,
            action_element_value: displayTitle,
        });
        props.setExpandedAccordionOnDetailsPage(href, isExpanded);
    };

    return (
        <Accordion
            level={props.level || 2}
            contentSummary={displayTitle}
            actionType="chevron-icon"
            view={view}
            data-element-name="activities-accordion-container"
            data-testid={elementName}
            onToggle={onToggle}
            ref={ref}
        >
            {props.children}
        </Accordion>
    );
};

AccordionContainer.displayName = 'AccordionContainer';

export default connect(mapStateToProps, mapDispatchToProps)(AccordionContainer);
